export const SUPER_ADMIN = "Super Admin";
export const PROJECT_ADMIN = "Project Admin";
export const ENGINEER = "Engineer";
export const SUBCONTRACTOR = "Sub Contractor";
